import { createContext } from "react";

// The floating meeting TOC's positioning is owned by the host page
// (MeetingPage / ProfilePage), rendered as a sibling of the right-sidebar so
// the offset is computed in ONE place instead of two coupled offsets that
// have to be kept in sync across breakpoints. MeetingPageList / ProfileOneonone
// still own the TOC's data and render <MeetingPageTOC /> via createPortal into
// the dock element here. `sidebarVisible` is exposed so consumers (e.g. the
// inline header chevrons in PreviousMeetingsPopoverPanel) know when the
// floating TOC has room to render and when they need to take over.
export type MeetingTOCDockContextValue = {
  dockEl: HTMLElement | null;
  sidebarVisible: boolean;
};

export const MeetingTOCDockContext = createContext<MeetingTOCDockContextValue>({
  dockEl: null,
  sidebarVisible: false,
});
